import { UserOrder } from "../../../../store/slice/userSlice";
import "./OrderDetails.scss";
import React from "react";

const OrderDetails: React.FC<{ order?: UserOrder }> = ({ order }) => {
  // const onReorder = () => {
  //   console.log("onReorder");
  // };

  // const onDownloadInvoice = () => {
  //   console.log("onDownloadInvoice");
  // };

  return (
    <div className="order-details">
      {/* <div className="action-buttons">
        <button onClick={onDownloadInvoice}>Télécharger ma facture</button>
        <button onClick={onReorder}>Commander à nouveau</button>
      </div> */}
      <section className="products">
        <h3>Articles ({order?.items?.length})</h3>
        {order?.items?.map((product) => (
          <div key={product.productCode} className="product">
            <div className="image-placeholder">
              {/* {product?.ImageUrl ? (
                <img src={product?.ImageUrl} alt={product?.designation} />
              ) : ( */}
              <div className="empty" />
              {/* )} */}
            </div>
            <div className="product-info">
              <p className="name">{product.designation}</p>
              {/* <p className="ref">Réf. {product.reference}</p> */}
              <p className="price">{product.unitPriceHT} €</p>
            </div>
            <div className="qty">Qté. {product.quantity}</div>
          </div>
        ))}
      </section>

      <section className="details">
        <div className="block no-border">
          <h4>Adresse de livraison</h4>
          {/* <p>{order?.address.fullName}</p>
          <p>{order?.address.addressLine1}</p>
          <p>{order?.address.addressLine2}</p>
          <p>
            {order?.address.postalCode} {order?.address.city}
          </p>
          <p>{order?.address.country}</p> */}
        </div>

        <div className="block">
          <h4>Mode de livraison</h4>
          <p>Standard</p>
        </div>

        <div className="block">
          <h4>Mode de paiement</h4>
          <p>Compte client</p>
        </div>

        <div className="block">
          <h4>Adresse de facturation</h4>
          {/* <p>{order?.address.fullName}</p>
          <p>{order?.address.addressLine1}</p>
          <p>{order?.address.addressLine2}</p>
          <p>
            {order?.address.postalCode} {order?.address.city}
          </p>
          <p>{order?.address.country}</p> */}
        </div>
      </section>
    </div>
  );
};

export default OrderDetails;
